<template>
  <div class="home-banner">
    <div class="lo-container">

      <div class="lo-12-xs lo-4-sm -gap-32px">

        <div class="_dp-f _fdrt-r _fdrt-cl-sm _alit-ct-sm _jtfct-fst-sm _pst-rlt _mgbt-32px _mgbt-0px-sm">
          <img src="~@/assets/home/atomic.svg" class="_w-128px _h-128px _w-256px-sm _mxw-100pct-sm _h-256px-sm _mgr-0px-sm _pst-asl _pst-rlt-sm _opct-20 _opct-100-sm _l-0px _r-0px _mgh-at _mgh-0px-sm" alt="atomic">
          <div>
            <h4 class="_tal-ct-sm _mgbt-8px">ATOMIC</h4>
            <p class="_tal-l _fs-5 _lh-150pct">
              Atomic Class ที่ยืดหยุ่น และคลอบคลุมการใช้งานตามที่คุณต้องการ
            </p>
          </div>
        </div>

        <div class="_dp-f _fdrt-r _fdrt-cl-sm _alit-ct-sm _pst-rlt _mgbt-32px _mgbt-0px-sm">
          <img src="~@/assets/home/components.svg" class="_w-128px _h-128px _w-256px-sm _mxw-100pct-sm _h-256px-sm _mgr-0px-sm _pst-asl _pst-rlt-sm _opct-20 _opct-100-sm _l-0px _r-0px _mgh-at _mgh-0px-sm" alt="component">
          <div>
            <h4 class="_tal-ct-sm _mgbt-8px">COMPONENTS</h4>
            <p class="_tal-l _fs-5 _lh-150pct">
              มี Components และ Utility พื้นฐานเพื่อให้คุณเริ่มทำงานง่ายขึ้น
            </p>
          </div>
        </div>

        <div class="_dp-f _fdrt-r _fdrt-cl-sm _alit-ct-sm _pst-rlt _mgbt-32px _mgbt-0px-sm">
          <img src="~@/assets/home/responsive.svg" class="_w-128px _h-128px _w-256px-sm _mxw-100pct-sm _h-256px-sm _mgr-0px-sm _pst-asl _pst-rlt-sm _opct-20 _opct-100-sm _l-0px _r-0px _mgh-at _mgh-0px-sm" alt="responsive">
          <div>
            <h4 class="_tal-ct-sm _mgbt-8px">RESPONSIVE</h4>
            <p class="_tal-l _fs-5 _lh-150pct">
              ระบบ Responsive ที่สะดวก และใช้งานง่าย
            </p>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'HomeBenefits'
  }
</script>



// WEBPACK FOOTER //
// HomeBenefits.vue?630ccbf3